<template>
  <div class="title-desc">
    <a
      class="mb-0 right-col--link title-desc-link"
      @click="openEditDescription"
      v-show="!isEditDescAreaVisible"
    >Add a longer description</a>
    <div
      class="title-desc-edit-wrapper"
      v-show="isEditDescAreaVisible"
      :key="'desc_wrapper' + keyUndoRedo"
    >
      <p class="mb-2 title-desc-info">
        {{ noteTitleDes }}
      </p>
      <TextArea
        @interface="handleEmitUpdateSlide"
        :val="slideActive.titleDesc"
        v-if="reloadTitleDesc"
        :place-holder="descPlaceholder"
        rows="2"
        limit="250"
        :id-name="'title-desc-edit'"
        :index="''"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TextArea from '@/components/presentations/TextArea'
import EventBus from '@/eventBus'

export default {
  components: {
    TextArea,
  },
  props: {
    keyUndoRedo: {
      type: [String, Number],
      default: null,
    },
    reloadTitleDesc: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      isEditDescAreaVisible: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    noteTitleDes() {
      if (this.slideActive.type === 'question') {
        return "The longer description will be showed on your audience's devices. You can also show it while presenting by hovering on the slide title."
      }
      return "The longer description will be showed on your audience's devices. You can also show it while presenting by hovering your question title."
    },
    descPlaceholder() {
      if (this.slideActive.type === 'question') {
        return 'Description for your Q&A session…'
      }
      return 'Description for your question…'
    },
  },
  mounted() {
    if (this.slideActive.titleDesc) this.isEditDescAreaVisible = true
    EventBus.$on('updateTitleDesc', () => {
      if (this.slideActive.titleDesc) {
        this.isEditDescAreaVisible = true
        return
      }
      this.isEditDescAreaVisible = false
    })
  },
  destroyed() {
    EventBus.$off('updateTitleDesc')
  },
  methods: {
    openEditDescription() {
      this.isEditDescAreaVisible = true
    },
    handleEmitUpdateSlide(data) {
      this.$emit('updateSlide', data)
    },
  },
}
</script>

<style lang="scss" scoped>
.title-desc {
  .title-desc-link {
    font-size: 0.875em;
  }
  .title-desc-edit-wrapper {
    .title-desc-info {
      opacity: 0.7;
      font-size: 0.875em;
    }
  }
}
</style>
